import type { ReactNode } from "react";
import cn from "~/utils/cn";
import useDesign from "../../useDesign";

// One heading style for every landing section, tuned per design (b is quieter and editorial).
export default function SectionTitle({
  id,
  title,
  lead,
  eyebrow,
  className,
}: {
  id?: string;
  title: ReactNode;
  lead?: ReactNode;
  eyebrow?: ReactNode;
  className?: string;
}) {
  const design = useDesign();
  return (
    <div className={cn("max-w-[42rem]", className)}>
      {eyebrow && <p className="mb-3 font-display text-[15px] font-bold leading-relaxed text-accent-text">{eyebrow}</p>}
      <h2
        id={id}
        className={cn(
          "text-balance font-display leading-[1.3] text-ink",
          design === "b" ? "text-[clamp(1.7rem,1.2rem+1.9vw,2.6rem)] font-extrabold" : "text-[clamp(1.75rem,1.2rem+2.4vw,3rem)] font-black",
        )}
      >
        {title}
      </h2>
      {lead && <p className="mt-3 max-w-[36em] text-[17px] leading-[1.9] text-ink-2 md:text-lg">{lead}</p>}
    </div>
  );
}
